import UploadingDialog from './UploadingDialog';

export default UploadingDialog;
